import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';
import { Venue } from '../../../types/Venue';

interface VenueSelectorProps {
  venues: Venue[];
  selectedVenue: Venue | null;
  onVenueChange: (venue: Venue) => void;
  loading: boolean;
}

const VenueSelector: React.FC<VenueSelectorProps> = ({
  venues,
  selectedVenue,
  onVenueChange,
  loading
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    const venueId = event.target.value;
    const selected = venues.find((venue) => venue.id === venueId);
    if (selected) {
      onVenueChange(selected);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <CircularProgress size={24} />
        <Typography variant="body2">Loading venues...</Typography>
      </Box>
    );
  }

  if (venues.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No venues available. Please create a venue first.
      </Typography>
    );
  }

  return (
    <FormControl fullWidth>
      <InputLabel id="venue-selector-label">Select Venue</InputLabel>
      <Select
        labelId="venue-selector-label"
        id="venue-selector"
        value={selectedVenue?.id || ''}
        label="Select Venue"
        onChange={handleChange}
      >
        {venues.map((venue) => (
          <MenuItem key={venue.id} value={venue.id}>
            {venue.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default VenueSelector;
